import { GdsService_OrderAdditionalServiceGdsServiceVip_Fragment, SegmentWithTransferFragment } from '@websky/graphql';

export const getIatasByServices = (
	services: GdsService_OrderAdditionalServiceGdsServiceVip_Fragment[],
	segments: SegmentWithTransferFragment[]
) => {
	const iataSet = new Set<string>();

	services.forEach(service => {
		service.allowedSegments.forEach(allowedSegments => {
			allowedSegments.forEach(segmentId => {
				const segment = segments.find(segment => segment.segment.id === segmentId);

				if (segment) {
					iataSet.add(segment.segment.departure.airport.iata);
					iataSet.add(segment.segment.arrival.airport.iata);
				}
			});
		});
	});

	return [...iataSet];
};
